module.exports = __webpack_public_path__ + "static/media/sdg17.cd7ba311.png";